import React, { Component } from 'react';

import { FormattedMessage } from 'react-intl';
import Form from 'react-bootstrap/Form';
import RichTextInput from '../../../../../../components/richTextInput/rich-text-input-view';

class ExtraContent extends Component{
  render(){
    return(
      <div>
        <Form.Check
          inline
          id="HasExtraContentCheckbox"
          label={<FormattedMessage id="qp-extra-content"/>}
          name="checkbox"
          value="extraContent"
          onClick={this.props.extraContentToggle}
        />
        {this.props.hasExtraContent ? 
          <RichTextInput
            content={this.props.content}
            onChange={this.props.changeExtraContent}
            textName="quizExtraInfo"
            language={this.props.language}
            subject={this.props.lessonSubject}
            grade={this.props.lessonGrade}
            limitFromRules={this.props.limitFromRules}
            fileRules={this.props.fileRules}
          /> 
          : ""}
      </div>
    );
  }
}

export default ExtraContent;